<!-- components/AgendaDayLabel.vue -->
<template>
  <span class="container">
    <span class="narrow" v-html="narrowLabel" />
    <span class="medium" v-html="mediumLabel" />
    <span class="unlimited" v-html="label" />
  </span>
</template>

<script setup>
import {computed} from "vue";
// import {useLog} from "@/composables/useLog";

// const log = useLog("AgendaDate");
const props = defineProps(["label"]);

const narrowAbbreviations = {
  Sunday: "",
  Monday: "",
  Tuesday: "",
  Wednesday: "",
  Thursday: "",
  Friday: "",
  Saturday: ""
};

const mediumAbbreviations = {
  Sunday: "Sun",
  Monday: "Mon",
  Tuesday: "Tue",
  Wednesday: "Wed",
  Thursday: "Thu",
  Friday: "Fri",
  Saturday: "Sat"
};

function abbreviate(label, abbreviations) {
  let result = label;
  for (const fullWord in abbreviations) {
    const abbreviation = abbreviations[fullWord];
    if (abbreviation === undefined || abbreviation === null) continue;
    if (!result.includes(fullWord)) continue;
    result = result.replace(fullWord, abbreviation);
  }
  result = result.replace(/<b>\s*[–—―-]\s*<\/b>/g, "");
  result = result.replace(/^\s*[–—―-]\s*/, " ").replace(/\s*[–—―-]\s*$/, " ");
  return result.trim();
}

const narrowLabel = computed(() => {
  if (!props.label) return "";
  return abbreviate(props.label, narrowAbbreviations).trim();
});

const mediumLabel = computed(() => {
  if (!props.label) return "";
  return abbreviate(props.label, mediumAbbreviations).trim();
});
</script>

<style scoped>
:is(span.narrow, span.medium, span.unlimited) {
  display: none;
}

body.narrow span.narrow {
  display: inline;
}

:is(body.medium, body.wide) span.medium {
  display: inline;
}

body.unlimited span.unlimited {
  display: inline;
}
</style>
